import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/MsConfigAuth";
import "./index.css";
// import { TokenRefresherProvider } from "./components/TokenRefresherProvider";
if (window.top !== window.self) {
  window.top.location = window.self.location;
}
const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));
let persistor = persistStore(store);
root.render(
  // <React.StrictMode>
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {/* <TokenRefresherProvider> */}
        <App />
        {/* </TokenRefresherProvider> */}
      </PersistGate>
    </Provider>
  </MsalProvider>
  // </React.StrictMode>
);
